export default {
	category: {
		add: 15,
		update: 10
	},
	priceBook: {
		config: 5,
		map: 10
	},
	branch: {
		config: 5,
		map: 10
	},
	product: {
		add: 35,
		update: 10
	}
};



// WEBPACK FOOTER //
// ./src/components/sync/SyncSetting.js